import request from '@/utils/request'
import global from '@/utils/global'

export function transferMedia2Url(mediaId) {
  return request({
    url: '/upload/media_id_to_url',
    method: 'post',
    data: {
      media_id: mediaId
    }
  })
}

export function uploadDoc(file) {
  const fileData = new FormData()
  fileData.append('data', file)
  return request({
    url: '/upload/doc',
    method: 'post',
    data: fileData
  })
}

export function fetchVideoStatus(query) {
  return request({
    baseURL: `${global.apiVideoUrl}/aa/v1`,
    timeout: 90000,
    url: '/upload/video',
    method: 'get',
    params: query
  })
}

export function fetchUploadStsToken() {
  return request({
    url: '/upload/sts/token',
    method: 'get'
  })
}

export function uploadPublic(file) {
  const fileData = new FormData()
  fileData.append('data', file)
  return request({
    url: '/upload/public',
    method: 'post',
    data: fileData
  })
}

export function uploadPrivate(file) {
  const fileData = new FormData()
  fileData.append('data', file)
  return request({
    url: '/upload/private',
    method: 'post',
    data: fileData
  })
}



// WEBPACK FOOTER //
// ./src/api/upload.js